import { transformText } from "@/composables/textUtils";
import translationsFile from "@/assets/files/translations";
import { useContextStore } from "@/stores/context";

const TranslationHandler = {
    /**
     * Gets translations from file
     * @returns {Object}
     */
    getAllTranslations() {
        return translationsFile;
    },

    /**
     * Tries to translate the sent text
     * Note
     * @param {String} text
     * @param {String} formatOpt 
     * @returns {String}
     */
    translate(text = '', formatOpt = ''){
        if (!text || text == '') {
            return text;
        }

        try {
            const context = useContextStore();
            const lang = context.getLang;

            const translations = this.getAllTranslations();
            if(translations[text] === undefined || translations[text] === null || translations[text] === '')
                return transformText(text, formatOpt);
            return translations[text][lang] === undefined || translations[text][lang] === null
                ? transformText(text, formatOpt)
                : transformText(translations[text][lang], formatOpt);
        } catch (error) {
            return text;
        }
    }
}

export default TranslationHandler;